module.exports = __webpack_public_path__ + "img/flag-MX.762fbb49.png";